module.exports = __webpack_public_path__ + "static/engajadoslab-f53d0fc2eadf7f92c5240d5d49104f5a.jpg";